module.exports = __webpack_public_path__ + "img/otp-code.20915bbb.jpg";